import styled from 'styled-components'
import { mildGray, softGray, blue, softBlue } from '../../styles/variables.js'

const List = styled.div`
  margin: 5px;
  margin-top: 20px;
`
const Item = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px;
  background: ${softGray};
  margin-bottom: 8px;
  border-radius: 4px;
`

const ItemContent = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
  &.collapsed {
    cursor: pointer;
    &:hover {
      opacity: 0.7;
    }
  }
`

const ItemFooter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`

const Locales = styled.div`
  margin-left: 10px;
  flex: 1 1;
`

const DeleteLink = styled.div`
  margin-right: 10px;
  margin-top: 34px;
  cursor: pointer;
  color: ${mildGray};
  transition: all .1s ease-in-out;
  flex: 0 0;
  max-height: 24px;
  font-size: 22px;
  &:hover {
    transform: scale(1.1);
    color: red;
  }
  &.collapsed {
    margin-top: 0px;
  }
`
const IconPlaceholder = styled.div`
  width: 24px;
`

const Collapse = styled.div`
  cursor: pointer;
  font-size: 16px;
  position: absolute;
  right: 20px;
  top: 5px;
  color: black;

  &.group {
    top: 10px;
  }

  &.collapseUp {
      top: 0;
      &:hover: {
        opacity: 0.7;
      }
  }
`

const Title = styled.div`
  padding-right: 50px;
  display: flex;
  flex-direction: row;
  & > img {
    height: 40px;
    max-height: 40px;
    min-width: 200px;
    margin-right: 10px;
    object-fit: cover;
  }
`

const Group = styled.div`
  border-top: 2px solid ${blue};
`
const GroupTitle = styled.div`
  color: ${blue};
  font-size: 26px;
  margin-bottom: 0;
  position: relative;
  cursor: pointer;
  padding: 10px 20px;
  display: flex;
  flex-direction: row;
  align-items: center;

  &:hover {
    background: ${softBlue};
  }

  &.expanded {
    margin-bottom: 10px;
  }
`
const GroupItems = styled.div`
`

const Counter = styled.span`
  display: inline-block;
  background: ${blue};
  color: white;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 13px;
  position: relative;
  margin-left: 10px;
`

export default {
  List,
  Item,
  ItemContent,
  ItemFooter,
  DeleteLink,
  Locales,
  IconPlaceholder,
  Collapse,
  Title,
  Group,
  GroupTitle,
  GroupItems,
  Counter,
}
